import React from 'react'
import FontAwesome from 'react-fontawesome'

import log from 'utils/logger' // eslint-disable-line

class ToggledSidebar extends React.PureComponent {
  constructor(...args) {
    super(...args)

    this.state = {
      open: false
    }

    this.body = React.createRef()
  }

  globalClickListener = evt => {
    // ignore click event happened inside the dropdown menu or in a modal
    if (this.body?.current?.contains(evt.target) ||
        evt.target.closest('.modal')) {
      log("local click")
      return
    }

    // else hide dropdown menu
    this.onToggle()
  }

  onToggle = () => {
    const open = !this.state.open
    this.setState({ open }, () => {
      if (open) {
        document.addEventListener('click', this.globalClickListener)
      } else {
        document.removeEventListener('click', this.globalClickListener)
      }
    })
  }

  buttonIcon() {
    return this.state.open ? <FontAwesome name='times' /> : <FontAwesome name='bars' />
  }

  mobileSidebar(className) {
    if (this.state.open) {
      return (
        <div ref={this.body} className={`${className} mobile`}>
          { this.props.children }
        </div>
      )
    } else {
      return null
    }
  }

  primarySidebar(className) {
    return (
      <div className={`${className} hidden-sm hidden-xs`}>
        { this.props.children }
      </div>
    )
  }
}

export class LeftSidebar extends ToggledSidebar {
  render() {
    return (
      <div id="sidebar" className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
        <div className="hidden-lg hidden-md">
          <a className={`btn toggle ${this.state.open ? 'open' : 'closed'}`} onClick={this.onToggle}>
            Navigation {this.buttonIcon()}
          </a>

          { this.mobileSidebar("sidebar-content") }
        </div>

        { this.primarySidebar("sidebar-content") }
      </div>
    )
  }
}

export class RightSidebar extends ToggledSidebar {
  render() {
    let className = ["col-sm-12 col-xs-12"]

    if (this.props.grid) {
      className.push(`col-lg-${this.props.grid} col-md-${this.props.grid}`)
    } else {
      className.push(`col-lg-2 col-md-2`)
    }

    if (this.props.push) {
      className.push(`col-lg-push-${this.props.push} col-md-push-${this.props.push}`)
    } else {
      className.push(`col-lg-push-8 col-md-push-8`)
    }

    return (
      <div id="right-sidebar-wrapper" className={className.join(' ')}>
        <div className="hidden-lg hidden-md">
          <a className={`btn toggle ${this.state.open ? 'open' : 'closed'}`} onClick={this.onToggle}>
            Settings {this.buttonIcon()}
          </a>

          { this.mobileSidebar("right-sidebar") }
        </div>

        { this.primarySidebar("right-sidebar") }
      </div>
    )
  }
}

// default two-column "main" element
export function NarrowMainPanel(props) {
  return (
    <div className='col-lg-8 col-md-8 col-sm-12 col-xs-12'>
      <div id="content-wrapper">
        { props.children }
      </div>
    </div>
  );
}

// default two-column "main" element
export function MainPanel(props) {
  let className = [ "col-sm-12 col-xs-12" ]

  if (props.grid) {
    className.push(`col-lg-${props.grid} col-md-${props.grid}`)
  } else {
    className.push(`col-lg-12 col-md-12`)
  }

  return (
    <div className={className.join(' ')}>
      <div id="content-wrapper">
        { props.children }
      </div>
    </div>
  );
}

// default three-column "main" element
export function MiddlePanel(props) {
  return (
    <div className="col-lg-8 col-md-8 col-lg-pull-2 col-md-pull-2 col-sm-12 col-xs-12">
      <div id="content-wrapper">
        { props.children }
      </div>
    </div>
  );
}

// default three-column "main" element
export function LeftPanel(props) {
  let className = [ "col-sm-12 col-xs-12" ]

  if (props.grid) {
    className.push(`col-lg-${props.grid} col-md-${props.grid}`)
  } else {
    className.push(`col-lg-8 col-md-8`)
  }

  if (props.pull) {
    className.push(`col-lg-pull-${props.pull} col-md-pull-${props.pull}`)
  } else {
    className.push(`col-lg-pull-2 col-md-pull-2`)
  }

  return (
    <div className={className.join(' ')}>
      <div id="content-wrapper">
        { props.children }
      </div>
    </div>
  );
}


function SoloPanel(props) {
  const { grid } = props

  const pad = ( 12 - grid ) / 2
  const gridClass = `col-lg-${grid} col-md-${grid}`
  const padClass  = pad > 0 ? `col-lg-push-${pad} col-md-push-${pad}` : ''
  const className = `${gridClass} ${padClass} col-sm-12 col-xs-12 content-panel`

  return (
    <div id="fullscreen">
      <div id="main" role="main">
        <div id="content-container" className="container">
          <div className="row">
            <div className={className}>
              { props.children }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SoloPanel.defaultProps = {
  grid: 12
}

export { SoloPanel }
